import { ReactRenderer } from "@tiptap/react";
import { Mention } from "@tiptap/extension-mention";
import { MentionList } from "./MentionList";

export const MentionNode = (users = []) => {
  return Mention.extend({
    addAttributes() {
      return {
        id: { default: null },
        label: { default: null },
      };
    },
    renderHTML({ node }) {
      return [
        "span",
        { class: "mentionNode", "data-id": node.attrs.id },
        `@${node.attrs.label}`,
      ];
    },
  }).configure({
    suggestion: {
      char: "@",
      items: () => [],
      render: () => {
        let reactRenderer;

        return {
          onStart: (props) => {
            reactRenderer = new ReactRenderer(MentionList, {
              editor: props.editor,
              props: { ...props, users },
            });
          },
          onUpdate: (props) => reactRenderer?.updateProps({ ...props, users }),
          onKeyDown: (props) => reactRenderer?.ref?.onKeyDown(props) || false,
          onExit: () => reactRenderer?.destroy(),
        };
      },
    },
  });
};
